import { Column, Row } from 'components/UIKit/Flex';
import QCErrorDownloadContainer from 'containers/DownloadContainers/QCErrorDownloadContainer';
import ErrorTypeFilter from './ErrorTypeFilter';
import SeverityFilter from './SeverityFilter';

const styles = {
  container: {
    backgroundColor: '#fafafa',
    borderBottom: '1px solid #e5e5e5',
    padding: '1rem',
  },
  row: {
    alignItems: 'center',
  },
  title: {
    fontFamily: 'inherit',
    fontSize: '1.3rem',
    fontWeight: 'inherit',
    textTransform: 'capitalize',
  },
};

const QCEntitiesToolbar = ({
  download,
  list: {
    data: {
      count,
      summary: errorTypes,
    },
    isDownloading,
    isFetching,
  },
  path,
  router: {
    location: {
      query: {
        error_type,
        severity,
        ...query
      },
    },
    params: {
      entity,
    },
  },
  title,
}): React.Element => (
  <Column
    style={styles.container}
    >
    <Row style={{ justifyContent: 'space-between' }}>
      <h1 style={styles.title}>
        {title}
      </h1>
      <Row style={styles.row}>
        <QCErrorDownloadContainer
          count={count}
          isDownloading={isDownloading}
          download={download}
          formats={['json', 'tsv']}
          >
            Download QC Report
        </QCErrorDownloadContainer>
      </Row>
    </Row>

    {!isFetching && (
      <Row style={styles.row}>
        <ErrorTypeFilter
          entity={entity}
          error_type={error_type}
          errorTypes={errorTypes}
          query={Object.assign(
            {},
            query,
            { severity },
          )}
          />

        <SeverityFilter
          query={Object.assign(
            {},
            query,
            { error_type },
          )}
          severity={severity}
          style={{ marginLeft: '1rem' }}
          />
      </Row>
    )}
  </Column>
);

export default QCEntitiesToolbar;
